<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active': isperspective == true }, 'toolbar-item']" @click="selectToobar('perspective');perspectiveeffect()">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">透 视</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="15" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Perspective</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'model'}, 'toolbar-item']" @click="selectToobar('model')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">型 号</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="31" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Version</textPath>
                            </text>
                        </g>
                        <!-- <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">型号</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                        </g> -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'perspective'">
                    <div
                      v-for="(item,index) in perspectiveObj"
                      :key="index"
                      :class="[{'active':perspectiveActive === item.id}, 'app-submenu-item']"
                      @click="perspectiveAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'model'">
                    <div
                      v-for="(item,index) in modelObj"
                      :key="index"
                      :class="[{'active':modelActive === item.id}, 'app-submenu-item']"
                      @click="modelAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { TrackballControls } from "three/examples/jsm/controls/TrackballControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // // 引入CSS3渲染器CSS3DRenderer
    // // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    var scene;

    export default {

        components: {
            Loader,
            Nav,
            language,
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                perspectiveActive:null,
                modelActive:0,
                lang: 'cn', // 语言
                animationtimeoutlist:[],
                rotatebtn:'', //旋转按钮
                rotationnumber:0,
                is_hidenote:true,

                perspectiveObj:[ //透视选项


                ],
                isperspective:false,
                modelObj: [ //型号选项
                  {
                    id: 0,
                    text: '交叉型静态混合器', //菜单显示
                    en_text: 'X Type Static Mixer', //菜单显示(英文)
                  },
                  {
                    id: 1,
                    text: '螺旋型静态混合器', //菜单显示
                    en_text: 'S Type Static Mixer', //菜单显示(英文)
                  },
                ],
            }
        },

        mounted: function () {
            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            // this.raycasterclick()

            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language'); // 存入一个值
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              //创建环境光
              _this.initAmbientLight();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;

              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;

              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);

              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);

          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;

              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 100);
            _this.camera.lookAt(_this.scene.position);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new TrackballControls(_this.camera, _this.renderer.domElement);

              _this.controls.rotateSpeed = 10;
              _this.controls.staticMoving = true;
              _this.controls.noPan = true;

              // _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              // _this.controls.enablePan = false; //启用或禁用摄像机平移
              // _this.controls.enableDamping = true; //启用阻尼
              // _this.controls.dampingFactor = 0.1; //阻尼惯性值
              // // _this.controls.maxPolarAngle = Math.PI;
              // // _this.controls.minPolarAngle = 0;
              // _this.controls.enablePan = false; //启用或禁用摄像机平移
              // _this.controls.enableZoom = true; //启用或禁用摄像机的缩放

          },

          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },
          /**
           * @description 初始化添加环境光
           */
          initAmbientLight: function() {
            let _this = this;
            const light = new THREE.AmbientLight( 0xeeeeee , 1 ); // 柔和的白光
            _this.scene.add( light );
          },
          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/jthhq/jthhq.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.init_model = gltf
                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.optimization_model_meaterial_performance()
                _this.animate();
                _this.model.getObjectByName("b1").visible = false
                _this.model.getObjectByName("b2").visible = false
                // _this.rotatemodel()
                // _this.toperspectiveto("b1",0.0,0)
                // _this.toperspectiveto("b2",0.0,0)
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            // let mixerUpdateDelta = _this.clock.getDelta();
            // _this.mixer.update( mixerUpdateDelta );
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
            }else{
              this.toobarActive = e;
            }
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                // console.log(object,'isMeshPhysicalMaterial');
                let now_material = object.material
                // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                let materialStandard = new THREE.MeshStandardMaterial({
                  color: now_material.color,
                  roughness: now_material.roughness, // 粗糙度
                  metalness: now_material.metalness, // 金属度
                  normalMap: now_material.normalMap, // 法线贴图
                  roughnessMap: now_material.roughnessMap, // 粗糙贴图
                  normalScale: now_material.normalScale, // 法线贴图强度
                  // 其他属性根据需要进行调整或者添加
                });
                // 将模型的材质替换为新的 MeshStandardMaterial
                object.material = materialStandard;
              }
            })
          },
          /**
           * @description 点击透视
           */
          perspectiveAnimate: function(item) {
            console.log('透视');
          },
          cancellationallsettimeout(){ //取消所有显示隐藏逻辑计时器
            for (let i = 0; i < this.animationtimeoutlist.length; i++) {
              clearTimeout(this.animationtimeoutlist[i])
            }
            this.animationtimeoutlist = []
          },
          /**
           * @description 选择型号
           * @param {item} e
           */
          modelAnimate: function(item) { //切换模型编号
            let _this = this
            console.log('型号');
            this.modelActive = item.id
            if(this.modelActive){
                _this.model.getObjectByName("a1").visible = false
                _this.model.getObjectByName("a2").visible = false
                _this.model.getObjectByName("a3").visible = false
                _this.model.getObjectByName("b1").visible = true
                _this.model.getObjectByName("b2").visible = true
                // this.toperspectiveto("a1",1.0,1000)
            }else{
                _this.model.getObjectByName("b1").visible = false
                _this.model.getObjectByName("b2").visible = false
                _this.model.getObjectByName("a1").visible = true
                _this.model.getObjectByName("a2").visible = true
                _this.model.getObjectByName("a3").visible = true
                // this.toperspectiveto("b1",1.0,1000)
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.rotatebtn]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
                _this.rotationnumber+=Math.PI/2
                new TWEEN.Tween({rotation:_this.model.rotation.z})//创建一段tween动画
                .to({rotation: _this.rotationnumber}, 1000)
                .onStart(function(){
                  //动画开始：允许透明opacity属性才能生效
                })
                .onUpdate(function(obj){
                  _this.model.rotation.z = obj.rotation
                  // console.log(obj.rotation);
                })
                .start();

              }else{
                console.log('null');
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
          },
          toperspectiveto(name,opacitynumber,opacitytimer){
            let _this = this
            _this.model.getObjectByName(name).traverse(function (object) {
              if (object.type === 'Mesh') {
                new TWEEN.Tween({opacity:object.material.opacity})//创建一段tween动画
                .to({opacity:opacitynumber}, opacitytimer)
                .onStart(function(){
                  //动画开始：允许透明opacity属性才能生效
                  object.material.transparent = true;//开启透明计算
                })
                .onUpdate(function(obj){
                  object.material.opacity = obj.opacity
                  // console.log(obj.opacity);
                })
                .start();
              }
            })
          },

          perspectiveeffect(){ //控制透视逻辑
            if(this.isperspective){
                console.log('取消透视');
                this.model.getObjectByName("a1").traverse(function (object) {
                  if (object.type === 'Mesh') {
                    object.material.transparent = true;
                    object.material.opacity = 0.3
                  }
                })
                this.model.getObjectByName("b1").traverse(function (object) {
                  if (object.type === 'Mesh') {
                    object.material.transparent = true;
                    object.material.opacity = 0.3
                  }
                })
                this.toperspectiveto("b1",1.0,1000)
                this.toperspectiveto("a1",1.0,1000)
                this.toperspectiveto("a3",1.0,1000)
                this.callAnimation(1)
            }else{
                console.log('透视');
                this.model.getObjectByName("a1").traverse(function (object) {
                  if (object.type === 'Mesh') {
                    object.material.transparent = true;
                    object.material.opacity = 1
                  }
                })
                this.model.getObjectByName("b1").traverse(function (object) {
                  if (object.type === 'Mesh') {
                    object.material.transparent = true;
                    object.material.opacity = 1
                  }
                })
                this.toperspectiveto("b1",0.3,1000)
                this.toperspectiveto("a1",0.3,1000)
                this.toperspectiveto("a3",0.1,1000)
                this.callAnimation(0)
            }
            this.isperspective = !this.isperspective
          },
          //生成旋转模型按钮
          rotatemodel(){
            let _this = this
              const texture = new THREE.TextureLoader().load("../../static/image/left.png");
              console.log(texture);
              // 创建精灵材质对象SpriteMaterial
              const spriteMaterial = new THREE.SpriteMaterial({
                color:0x000000,//设置颜色
                map: texture, //设置精灵纹理贴图
              });
              // 创建精灵模型对象，不需要几何体geometry参数
              _this.rotatebtn = new THREE.Sprite(spriteMaterial);
              // _this.rotatebtn.scale.set(1,1);  // 标注缩放
              _this.rotatebtn.name='rotatebtn';
              _this.rotatebtn.position.set(-10,10,0);  // 标注坐标
              this.model.add(_this.rotatebtn);
          },
          callAnimation(number){ //解析外部模型关键帧动画
            let _this =this
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            const mixer = new THREE.AnimationMixer(_this.model);
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = mixer.clipAction(_this.init_model.animations[number]); //创建动画clipAction对象
            _this.clipAction.play(); //播放动画
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true;
            // 如果想播放动画,需要周期性执行`mixer.update()`更新AnimationMixer时间数据
            const clock = new THREE.Clock();
            function loop() {
              requestAnimationFrame(loop);
              //clock.getDelta()方法获得loop()两次执行时间间隔
              const frameT = clock.getDelta();
              // 更新播放器相关的时间
              mixer.update(frameT);
            }
            loop()
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // console.log(this.model.rotation.z);
            // new TWEEN.Tween({rotation:_this.model.rotation.z})//创建一段tween动画
            // .to({rotation: Math.PI / 4}, 1000)
            // .onStart(function(){
            //   //动画开始：允许透明opacity属性才能生效
            // })
            // .onUpdate(function(obj){
            //   _this.model.rotation.z = obj.rotation
            //   // console.log(obj.rotation);
            // })
            // .start();
            // this.trackmouse()
            // this.model.rotation.z = Math.PI/4


          },
        }
    }
</script>

<style scoped>
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/jthhqmodel.vue